import React from 'react';
import { Box } from '@mui/material';

const LogoLoader = ({ size = 120, fullScreen = false }) => {
  const containerStyle = fullScreen ? {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)',
    zIndex: 9999
  } : {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  };

  return (
    <Box sx={containerStyle}>
      <style>
        {`
          @keyframes float {
            0%, 100% {
              transform: translateY(0px) scale(1);
            }
            50% {
              transform: translateY(-20px) scale(1.05);
            }
          }
          
          @keyframes pulse-glow {
            0%, 100% {
              opacity: 0.6;
              transform: scale(1);
            }
            50% {
              opacity: 1;
              transform: scale(1.1);
            }
          }
        `}
      </style>
      <Box sx={{ position: 'relative' }}>
        {/* Glow effect */}
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(circle, rgba(99, 102, 241, 0.4) 0%, transparent 70%)',
            filter: 'blur(30px)',
            width: size * 1.67,
            height: size * 1.67,
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            animation: 'pulse-glow 2s ease-in-out infinite'
          }}
        />
        
        {/* Logo */}
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/logo192.png`}
          alt="Vitria"
          sx={{
            position: 'relative',
            zIndex: 10,
            width: `${size}px`,
            height: `${size}px`,
            filter: 'drop-shadow(0 0 20px rgba(99, 102, 241, 0.5))',
            animation: 'float 2s ease-in-out infinite'
          }}
        />
      </Box>
    </Box>
  );
};

export default LogoLoader;
